import EnumSet from 'Services/enumSet'

interface ISubscriptionPeriods extends EnumSet {
  monthly: number
  quarterly: number
  biannual: number
  yearly: number
}

const subscriptionPeriods = new EnumSet({
  monthly: { value: 1, description: 'Mensal' },
  quarterly: { value: 2, description: 'Trimestral' },
  biannual: { value: 3, description: 'Semestral' },
  yearly: { value: 4, description: 'Anual' },
}) as ISubscriptionPeriods

export default subscriptionPeriods